const baseUrl = process.env.REACT_APP_BASEURL || "";
const recaptchaKey =
  process.env.REACT_APP_RECAPTCHAKEY || "6LfH6aQrAAAAAOMntE8Tes8TzGdXo0FowMTYn6Pk";
//AMP settings
const ampBaseUrl =
  process.env.REACT_APP_AMP_BASEURL || "https://prod2-api-mportal.ascentis.com.sg";
const ampXHost = process.env.REACT_APP_AMP_XHOST || "members.skechers.com.sg";
const getOtpEndpoint =
  process.env.REACT_APP_GET_OTP_ENDPOINT || "/api/Crm/GetOtp";
const validateOtpEndpoint =
  process.env.REACT_APP_VALIDATE_OTP_ENDPOINT ||
  "/api/Crm/ValidateOtp";
const smsMaskName =
  process.env.REACT_APP_SMS_MASK_NAME || "Mr. Coconut";
const smsMessage =
  process.env.REACT_APP_SMS_MESSAGE || "[OTP] is your code for the Mr. Coconut, please don&rsquo;t share it.";
const options = process.env.REACT_APP_OPTIONS || "X";
const charLen = parseInt(
  process.env.REACT_APP_CHARLEN || "6"
);
const appNameBase64 =
  process.env.REACT_APP_APP_NAME_BASE_64 || "TXJDb2NvbnV0";
const captchaSiteKey =
  process.env.REACT_APP_CAPTCHA_SITE_KEY || "6LfH6aQrAAAAAOMntE8Tes8TzGdXo0FowMTYn6Pk";
const validateOtpIgnoreCase =
  (process.env.REACT_APP_VALIDATE_OTP_IGNORE_CASE ||
    "true") === "true"
    ? true
    : false;
const validateOtpTimeIntervalType =
  process.env.REACT_APP_VALIDATE_OTP_TIME_INTERVAL_TYPE ||
  "Minutes";
const validateOtpTimeIntervalValue = parseInt(
  process.env.REACT_APP_VALIDATE_OTP_TIME_INTERVAL_VALUE ||
    "3"
);

const ampSettings = {
  baseUrl: ampBaseUrl,
  xHost: ampXHost,
  getOtpEndpoint,
  validateOtpEndpoint,
  smsMaskName,
  smsMessage,
  options,
  charLen,
  appNameBase64,
  captchaSiteKey,
  validateOtpIgnoreCase,
  validateOtpTimeIntervalType,
  validateOtpTimeIntervalValue
};

const languages = [
  { name: "English", code: "en" },
  { name: "Vietnamese", code: "vi" }
];
const currency = "$";
// need to update recaptcha domain once moved to production
const appStoreUrl = "#";
const ggStoreUrl = "#";
const maxTransferAmount = 5000000;
const timeoutConfigs = {
  warnTimeoutMins: 8,
  logoutTimeoutMins: 10,
  refreshIntervalMins: 8
};
const captchaThreshold = 0;
const noOfStarsForFreeDrink = 25;
const qrCodePrefix = "https://www.abbott.com.sg/gift-card/?cardno=";
const herokuPassword = "asc_abbott@2019";
const gmapsAPI = "asfDWD9793";

export {
  baseUrl,
  languages,
  currency,
  recaptchaKey,
  maxTransferAmount,
  appStoreUrl,
  ggStoreUrl,
  timeoutConfigs,
  captchaThreshold,
  noOfStarsForFreeDrink,
  herokuPassword,
  qrCodePrefix,
  ampSettings
};



// WEBPACK FOOTER //
// ./src/configs/Settings.js